export const TabBar = {
  'zh-CN': {
    title: '标签栏',
    settings: {
      'x-component-props': {
        tabs: '数据',
        defaultActiveKey: '默认选中',
        children: '标题',
        title: '标题',
      },
    },
  },
}
